import script from "./NuvemCallback.vue?vue&type=script&lang=js"
export * from "./NuvemCallback.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__